var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.146894 0.146894C0.193339 0.100331 0.248515 0.0633878 0.30926 0.0381813C0.370005 0.0129749 0.435126 0 0.500894 0C0.566661 0 0.631782 0.0129749 0.692527 0.0381813C0.753272 0.0633878 0.808448 0.100331 0.854894 0.146894L6.85489 6.14689C6.90146 6.19334 6.9384 6.24852 6.96361 6.30926C6.98881 6.37001 7.00179 6.43513 7.00179 6.50089C7.00179 6.56666 6.98881 6.63178 6.96361 6.69253C6.9384 6.75327 6.90146 6.80845 6.85489 6.85489L0.854894 12.8549C0.761007 12.9488 0.633669 13.0015 0.500894 13.0015C0.368118 13.0015 0.24078 12.9488 0.146894 12.8549C0.0530069 12.761 0.000261784 12.6337 0.000261784 12.5009C0.000261784 12.3681 0.0530069 12.2408 0.146894 12.1469L5.79389 6.50089L0.146894 0.854894C0.10033 0.808448 0.0633873 0.753273 0.0381808 0.692528C0.0129744 0.631782 0 0.566661 0 0.500894C0 0.435127 0.0129744 0.370005 0.0381808 0.30926C0.0633873 0.248515 0.10033 0.19334 0.146894 0.146894Z",
    fill: "#FFFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.80fdc6256d1879ed1c716c00ffebabc7.svg";
export { ForwardRef as ReactComponent };